import React from "react";
import { Route, Routes } from "react-router-dom";
// import { useSelector } from "react-redux";
import ListFeaturedBusinessProperty from "../Components/Featured Business Property/listfeaturedBusniessProperty";


const FeaturedBusinessPropertyRoutes = () => {
  // const { admin } = useSelector((state) => state.admin || {});
  // const accessCode = admin?.data?.access_code || [];

  // const canAdd = Array.isArray(accessCode) && accessCode.includes("add");
  // const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

  return (
    <Routes>
      <Route path="/featured_business_property" element={<ListFeaturedBusinessProperty />} />
      {/* <Route
        path="/featured_business_property_list"
        element={canAdd ? <FeaturedBusinessPropertyList /> : <Navigate to="/dashboard" replace />}
      />
      <Route
        path="/featured_business_property/add"
        element={canAdd ? <AddFeaturedBusinessProperty /> : <Navigate to="/dashboard" replace />}
      /> */}
    </Routes>
  );
};

export default FeaturedBusinessPropertyRoutes;